import { createRpcMutation } from './factory'

export const useUpsertUserOrganization = createRpcMutation({
   fn: 'upsert_user_organization',
   successKey: (vars) =>
      vars.p_user_id ? 'info.user-organization-updated' : 'info.user-organization-created',
   invalidates: (props) => [
      ['organization', { id: props.p_organization_id }],
      ['user-organization', { userId: props.p_user_id, organizationId: props.p_organization_id }],
   ],
})
